module.exports = __webpack_public_path__ + "img/klcx_02.2225b3f3.jpg";